// extracted by mini-css-extract-plugin
export var closeButton = "_f5-1";
export var closeX = "_f5-3";
export var container = "_f5-0";
export var image = "_f5-2";